import type { Allocated } from "./Allocated"

/** Generic WASM instance with memory management helpers */
export type WasmInstance = {
  /** Raw WASM exports object (use for module-specific function calls) */
  readonly exports: Record<string, unknown>
  /** Register a JS callback in the indirect function table */
  readonly addCallback: (
    fn: (...args: number[]) => number | bigint,
    sig: string
  ) => Allocated
  /** Re-initialize the instance (re-instantiate from compiled module) */
  readonly init: () => Promise<void>
  /** Dispose all exports (cleanup) */
  readonly dispose: () => Promise<void>
  /** True when running a memory64 WASM module (pointers are BigInt) */
  readonly memory64: boolean
}
